import { createBrowserRouter, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AuthLayout } from "./components/AuthLayout";
import { RequireAuth } from "./components/RequireAuth";
import { Home } from "./pages/Home";
import { Markets } from "./pages/Markets";
import { Trade } from "./pages/Trade";
import { Watchlist } from "./pages/Watchlist";
import { Portfolio } from "./pages/Portfolio";
import { Alerts } from "./pages/Alerts";
import { Intel } from "./pages/Intel";
import { Academy } from "./pages/Academy";
import { Settings } from "./pages/Settings";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { NotFound } from "./pages/NotFound";
import { Admin } from "./pages/Admin";
import { Providers } from "./pages/Providers";
import { Orders } from "./pages/Orders";

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/markets", element: <Markets /> },
      { path: "/trade", element: <Navigate to="/trade/BTCUSDT" replace /> },
      { path: "/trade/:symbol", element: <Trade /> },
      { path: "/intel", element: <Intel /> },
      { path: "/academy", element: <Academy /> },
      {
        element: <RequireAuth />,
        children: [
          { path: "/watchlist", element: <Watchlist /> },
          { path: "/portfolio", element: <Portfolio /> },
          { path: "/orders", element: <Orders /> },
          { path: "/providers", element: <Providers /> },
          { path: "/alerts", element: <Alerts /> },
          { path: "/settings", element: <Settings /> },
          { path: "/admin", element: <Admin /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    element: <AuthLayout />,
    children: [
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <Signup /> },
    ],
  },
]);
